import api from './client';
import type { AxiosResponse } from 'axios';

export type Testimonial = {
  id: string;
  name: string;
  location?: string;
  rating: number;
  quote: string;
  source: 'manual' | 'app_store' | 'play_store';
  avatar_url?: string;
  approved: boolean;
  created_at?: string;
};

export type TestimonialBody = Omit<Testimonial, 'id' | 'created_at'>;

export const getPublicTestimonials = (limit = 8): Promise<AxiosResponse<{ testimonials: Testimonial[]; total: number }>> =>
  api.get(`/testimonials/public?limit=${limit}`);

export const getAdminTestimonials = (): Promise<AxiosResponse<Testimonial[]>> =>
  api.get('/admin/testimonials');

export const createTestimonial = (body: TestimonialBody): Promise<AxiosResponse<Testimonial>> =>
  api.post('/admin/testimonials', body);

export const updateTestimonial = (id: string, body: TestimonialBody): Promise<AxiosResponse<Testimonial>> =>
  api.put(`/admin/testimonials/${id}`, body);

export const deleteTestimonial = (id: string): Promise<AxiosResponse> =>
  api.delete(`/admin/testimonials/${id}`);

export const syncStoreTestimonials = (): Promise<AxiosResponse> =>
  api.post('/admin/testimonials/sync');
